import { EventHandlerBase, Primitive } from "pytha2";
import { AxisNetPrimitive } from "../primitive/AxisNetPrimitive";
import { Storey } from "@/declare/interface/project/storey";



/**
 * 删除竖向轴线
 */
export class EventHandlerDeletVerticalAxisLine extends EventHandlerBase {

    run(data?: {}) {
        const params = this.node.graph.cache.inputObject['PARAMS'];
        const deleteStoreys: Storey[] = params?.deleteStoreys || [];
        const storeys: Storey[] = params?.storeys || [];
        let storeyUuidSet = new Set(storeys?.map(item => item.uuid) || []);
        deleteStoreys?.forEach(item => {
            storeyUuidSet.add(item.uuid);
        })

        const storage = this.getPythaStorage();

        let verticalAxisLines = Object.keys(storage.primitiveStore.primitiveDict)?.map(key => {
            let entity = storage.primitiveStore.primitiveDict[key];
            // 是竖向轴线，并且相关的轴网uuid均存在
            if (entity.type === 'VerticalAxisLine'
                && storeyUuidSet.has((entity as AxisNetPrimitive)?.axisNetUuids[0])
                && storeyUuidSet.has((entity as AxisNetPrimitive)?.axisNetUuids[1])
                // && (entity as AxisNetPrimitive)?.axisNetUuids?.some(item => deleteStoreyUuidSet?.has(item))
                // && (entity as AxisNetPrimitive)?.axisNetUuids?.some(item => storeyUuidSet?.has(item))
            ) {
                return entity;
            }

            return null;
        })?.filter(item => !!item) || [];
        verticalAxisLines?.forEach(primitive => {
            primitive.needDelete = true;
        })

        return true;
    }
}